import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-welcome-box',
  imports: [],
  templateUrl: './welcome-box.component.html',
  styleUrl: './welcome-box.component.css',
})
export class WelcomeBoxComponent {
  doctorName: string = '';

  getDoctorName(): string {
    const userSettings = JSON.parse(
      localStorage.getItem('userSettings') || '{}',
    );
    const userInfo = userSettings.userInfo || {};
    const first_name = userInfo.first_name;
    const last_name = userInfo.last_name;

    return `${first_name} ${last_name}`;
  }
}
